<template>
  <div v-if="priceData.mainPrice" class="slider__car--block">
    <p class="slider__car--font">
      {{ priceData.label }}
    </p>

    <div class="slider__car--description">
      <p class="slider__car--price">
        {{ priceData.formatter(priceData.mainPrice) }} zł
        <span class="slider__car--font">{{ priceData.category_id != 2? 'brutto' : 'netto' }}</span>
      </p>
    </div>

    <p v-if="priceData.secondaryPrice" class="slider__car--font">
      {{ priceData.secondaryPriceLabel }}
      <span>{{ priceData.formatter(priceData.secondaryPrice) }} zł {{ priceData.category_id != 2? 'brutto' : 'netto' }}</span>
    </p>
  </div>
</template>

<script>
import { useStore } from "../../store";
import { formatPrice } from "../../plugins/helpers";

export default {
  computed: {
    mainOffer() {
      const offer = useStore().getMainOffer;
      return offer && offer.length > 0 ? offer[0] : null;
    },

    isUsedCar() {
      return this.mainOffer?.typeId === 2;
    },

    priceData() {
      const offer = this.mainOffer;

      if (!offer) {
        return { mainPrice: null };
      }

      if (offer.forYouPrice) {
        const showSecondary = offer.catalogPrice && offer.catalogPrice > offer.forYouPrice;
        
        return {
          label: this.$t("offerForYou"),
          mainPrice: offer.forYouPrice,
          secondaryPrice: showSecondary ? offer.catalogPrice : null,
          secondaryPriceLabel: this.isUsedCar ? this.$t("offerPrice") : this.$t("catalogPrice"),
          category_id: offer.category_id,
          formatter: (price) => formatPrice(price, false),
        };
      }

      if (offer.catalogPrice) {
        return {
          label: this.isUsedCar ? this.$t("offerPrice") : this.$t("catalogPrice"),
          mainPrice: offer.catalogPrice,
          secondaryPrice: null,
          category_id: offer.category_id,
          formatter: (price) => formatPrice(price, false),
        };
      }

      return {
        label: "",
        mainPrice: null,
        secondaryPrice: null,
        formatter: (price) => price,
      };
    },
  },
  methods: {
    formatPrice,
  },
};
</script>